export const defaultFdsEmpresa = () => {
  return {
    id_empresa: null,
    nombre_empresa: '',
    nit: null,
    telefono: '',
    telefono_emergencia: '',
    direccion: '',
    datos_adicionales: '',
  };
};

export const defaultFdsEmpresaParametros = () => {
  return {
    id_empresa: null,
    id_modelo_fds: null,
    id_modelo_te: null,
    id_versionamiento: null,
    cantidad_fds: null,
    activo: null,
  }
}

export const defaultFdsListasParametros = () => {
  return {
    fds_modelos_fds: [],
    fds_versionamiento: []
  }
}

export default {
  id_empresa: null,
  selectedFdsEmpresa: defaultFdsEmpresa(),
  selectedFdsEmpresaParametros: defaultFdsEmpresaParametros(),
  fdsListasParametros: defaultFdsListasParametros(),
  accion: 'crear',
  vista: null,
};
